export default __webpack_public_path__ + "static/media/home-inactive.4de6dbfe.svg";